import {Component, Input, OnInit, Optional} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {FormGroup, FormControl} from '@angular/forms';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';
import {VccChartFilterResult} from '../../../../model/funding-vcc-chart-filter';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {Merchant} from '../../../../model/merchant-guid';
import {Subscription} from 'rxjs';
import {MerchantsService} from 'src/infrastructure/merchants/service/merchants.service';

@AutoUnsubscribe()
@Component({
    selector: 'vcc-chart-filter-modal',
    templateUrl: './vcc-chart-filter-modal.component.html',
    standalone: false
})

export class VccChartFilterModalComponent implements OnInit {
  @Input() config!: VccChartFilterResult;

  VccChartFilterForm!: FormGroup;
  formBuilder: any;
  merchantGuids: Merchant[] = [];
  breakPoint$?: Subscription;
  isSmall: boolean = false;

  maxDate: Date = new Date();
  minDate: Date = new Date();

  constructor(
    @Optional() public dialogRef: MatDialogRef<VccChartFilterModalComponent>,
    private merchantsService: MerchantsService,
    breakpointObserver: BreakpointObserver,
  ) {
    this.breakPoint$ = breakpointObserver.observe([
      Breakpoints.Medium,
      Breakpoints.Small,
      Breakpoints.XSmall
    ]).subscribe(result => {
      this.isSmall = result.matches;
    });
  }

  form: FormGroup = new FormGroup({
    merchantGuid: new FormControl(null),
    releasedDateFrom: new FormControl(null),
    releasedDateTo: new FormControl(null)
  });

  ngOnInit(): void {
    const now = new Date();
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(now.getMonth() - 1);

    this.maxDate = now;
    this.minDate = oneMonthAgo;

    this.form.patchValue({
      releasedDateFrom: oneMonthAgo,
      releasedDateTo: now,
      ...this.config
    });

    this.merchantsService.merchants$.subscribe((data) => {
      this.merchantGuids = data;
    });
  }

  handleVccChartFiltersFormCloseEvent(): void {
    if (this.dialogRef) {
      this.dialogRef.close(null);
    }
  }

  clearVccChartFilters(propertyName: string): void {
    if (propertyName === 'all') {
      this.config = {} as VccChartFilterResult;
      this.form.reset();
    } else {
      this.form.get(propertyName)?.setValue(null);
      
      const temp = { ...this.config };
      delete temp[propertyName as keyof VccChartFilterResult];
      this.config = temp;
    }
  }

  applyVccChartFilters(): void {
    this.config = this.form.value;
    
    if (this.form.invalid) {
      this.form.markAllAsTouched();
    } else if (this.dialogRef) {
      this.dialogRef.close(this.config);
    }
  }
}
